const menulist = () => {
  const list = [
    {
      main: { title: 'Dashboard', icon: 'ti-dashboard', link: '/dashboard' }
    },
    {
      main: { title: 'Duty Task', icon: 'ti-blackboard', link: '/#', roles: ['AD', 'AD_A', 'ALW'] },
      submenu: [
        { title: 'Active', link: '/duty-act' },
        { title: 'Complete', link: '/duty' },
      ]
    },
    {
      main: { title: 'Employee', icon: 'ti-user', link: '/#', roles: ['USR', 'AD'] },
      submenu: [
        { title: 'Attendance', link: '/emp-attendance', roles: ['AD', 'USR'] },
        { title: 'Permissions', link: '/permission', roles: ['AD', 'USR'] },
        { title: 'Profile', link: '/emp-profile', roles: ['AD', 'USR'] },
        // { title: 'Mobile Check-IN', link: '/mobile-check-in', roles: ['AD', 'USR'] },
      ],
    },
    {
      main: { title: 'HR', icon: 'ti-user', link: '/#', roles: ['AD', 'HRD'] },
      submenu: [
        { title: 'Attendance', link: '/att', roles: ['AD', 'HRD'] },
        { title: 'Employee', link: '/emp', roles: ['AD', 'HRD'] },
        { title: 'Permissions', link: '/hr-permissions', roles: ['AD', 'HRD'] },
      ],
    },
    {
      main: { title: 'Accounting', icon: 'ti-bag', link: '/#', roles: ['AD', 'AD_A', 'AD_F', 'FIN', 'ALW'] },
      submenu: [
        { title: 'Cash & Bank', link: '/cash-bank', roles: ['AD', 'AD_A', 'AD_F', 'FIN'] },
        { title: 'Sales', link: '/sell', roles: ['AD', 'AD_A', 'AD_F', 'FIN'] },
        { title: 'Purchase', link: '/buy', roles: ['AD', 'AD_A', 'AD_F', 'FIN'] },
        { title: 'Expense', link: '/expense', roles: ['AD', 'AD_A', 'AD_F', 'FIN'] },
        { title: 'Journals', link: '/journals', roles: ['AD', 'AD_A', 'AD_F', 'FIN'] },
        { title: 'Trial Balance', link: '/tb', roles: ['AD', 'AD_A', 'AD_F', 'FIN'] },
        { title: 'Reimbursements', link: '/reimbursements', roles: ['AD', 'AD_A', 'AD_F', 'FIN'] },
      ],
      id_main: 'acc-menu',
      id_submenu: 'acc-submenu'
    },
    {
      main: { title: 'Purchasing', icon: 'ti-money', link: '/#', roles: ['AD', 'AD_PC', 'PC'] },
      submenu: [
        { title: 'Dashboard', link: '/pc-dash', roles: ['AD', 'AD_PC', 'PC'] },
        { title: 'Requests', link: '/pc-req', roles: ['AD', 'AD_PC', 'PC'] },
        { title: 'PO', link: '/pc-po', roles: ['AD', 'AD_PC', 'PC'] },
      ]
    },
    {
      main: { title: 'Production', icon: 'ti-home', link: '/#', roles: ['AD', 'AD_PD','PD'] },
      submenu: [
        { title: 'Dashboard', link: '/pd-dash', roles: ['AD', 'AD_PD', 'PC'] },
        { title: 'Production', link: '/pd-req', roles: ['AD', 'AD_PD', 'PC'] },
        // { title: 'PO', link: '/pd-po', roles: ['AD', 'AD_PD', 'PC'] },
      ]
    },
    {
      main: { title: 'Warehouse', icon: 'ti-home', link: '/#', roles: ['AD', 'AD_WH', 'AD_STR', 'STR', 'WH'] },
      submenu: [
        // { title: 'Warehouse', link: '/warehouses', roles: ['AD', 'AD_WH', 'AD_STR', 'STR', 'WH'] },
        { title: 'Products & Items', link: '/pi', roles: ['AD', 'AD_WH', 'AD_STR', 'STR', 'WH'] },
        { title: 'Part Request', link: '/store', roles: ['AD', 'AD_WH', 'AD_STR', 'STR', 'WH'] },
        { title: 'Store Request', link: '/store-req', roles: ['AD', 'AD_WH', 'AD_STR', 'STR', 'WH'] },
        { title: 'Delivery', link: '/delivery', roles: ['AD', 'AD_WH', 'AD_STR', 'STR', 'WH'] },
       
      ]
    },
    {
      main: { title: 'Maintenance', icon: 'ti-settings', link: '/#', roles: ['AD', 'AD_PPC', 'PPC', 'AD_CI', 'CI', 'AD_MT', 'MT', 'ENG'] },
      submenu: [
        { title: 'Engineer', link: '/eng-dash', roles: ['AD', 'AD_ENG', 'ENG'] },
        { title: 'PPC', link: '/ppc-dash', roles: ['AD', 'AD_PPC', 'PPC'] },
        { title: 'Chief Inspector', link: '/ci-dash', roles: ['AD', 'AD_CI', 'CI'] },
        { title: 'Manager Technic', link: '/mantech-dash', roles: ['AD', 'AD_MT', 'MT'] },
      ]
    },
    {
      main: { title: 'Bills', icon: 'ti-receipt', link: '/#', roles: ['AD', 'AD_A', 'AD_F', 'FIN', 'ALW'] },
      submenu: [
        { title: 'Allowance', link: '/bills', roles: ['AD', 'AD_A', 'ALW'] },
        { title: 'Outstanding', link: '/os', roles: ['AD', 'AD_F', 'FIN'] },
        { title: 'Reimbursement', link: '/rm', roles: ['AD', 'AD_F', 'FIN'] },
      ]
    },
    {
      main: { title: 'Master', icon: 'ti-settings', link: '/#', roles: ['AD', 'AD_A', 'AD_F', 'AD_STR'] },
      submenu: [
        { title: 'Accounting', link: '/accounting', roles: ['AD', 'AD_F'] },
        { title: 'Aircrafts', link: '/aircrafts', roles: ['AD'] },
        { title: 'Airports', link: '/airports', roles: ['AD'] },
        { title: 'Attendance', link: '/st-attendance', roles: ['AD'] },
        { title: 'Bank', link: '/st-bank', roles: ['AD', 'AD_F'] },
        { title: 'Building', link: '/st-building', roles: ['AD', 'AD_STR'] },
        { title: 'Currency', link: '/st-curr', roles: ['AD', 'AD_F'] },
        { title: 'Customers Data', link: '/customers', roles: ['AD', 'AD_F'] },
        { title: 'Job', link: '/st-job', roles: ['AD', 'AD_F', 'HRD'] },
        { title: 'Locations', link: '/st-locations', roles: ['AD', 'AD_A'] },
        { title: 'Schedule Time', link: '/st-sch-time', roles: ['AD'] },
        { title: 'Tax Data', link: '/tax', roles: ['AD', 'AD_F'] },
        { title: 'UoM', link: '/uom', roles: ['AD', 'AD_F', 'FIN', 'AD_STR', 'STR'] },
        { title: 'Vendor Data', link: '/vendors', roles: ['AD', 'AD_F'] },
      ]
    },
    {
      main: { title: 'Admin', icon: 'ti-star', link: '/#', roles: ['AD'] },
      submenu: [
        { title: 'Users', link: '/user-manage', roles: ['AD'] },
      ]
    },
    {
      main: { title: 'Bar', icon: 'ti-star', link: '/#', roles: ['AD', 'BAR', 'AD_BAR'] },
      submenu: [
        { title: 'Bar', link: '/bar', roles: ['AD', 'BAR', 'AD_BAR'] },
      ]
    },
    {
      main: { title: 'Report', icon: 'ti-file', link: '/#', roles: ['AD', 'AD_A', 'AD_F'] },
      submenu: [
        { title: 'Allowance', link: '/report-allowance', roles: ['AD', 'AD_A'] },
        { title: 'OS', link: '/report-os', roles: ['AD', 'AD_F'] },
        { title: 'Accounting', link: '/report-acc', roles: ['AD', 'AD_F'] },
        { title: 'Employee', link: '/report-emp', roles: ['AD'] }
      ]
    },
  ]
  return list
}

export {
  menulist
}